import lightTheme from '@/components/ykc-ui/styles/light';
import darkTheme from '@/components/ykc-ui/styles/dark';

export default {
  lightTheme,
  darkTheme,
};
